import React from "react";
import { useEffect } from "react";

import { TableAdv } from "../../../../../../../components";
import { mapTableRows } from "../../../../../../../utils";
import { usePagination } from "../../../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";

//import {fetchAllSubmissions} from '../../../../../../../redux/slices/bdmjobs/bdmjobsSlice';
//import { fetchAllSubmissions } from '../../../../../../../redux/slices/bdmjobs/bdmjobsApi';
//import     fetchClientSubmissionsStart from '../../../../../../../redux/slices/clientsubmissions/clientsubmissionsSlice';

//import fetechClinetSubmissions from '../../../../../../../redux/slices/clientsubmissions/clientsubmissionsApi';

import {
  fetchClientSubmissionsStart,
  clearClientSubmissions,
} from "../../../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { totalCountStart } from "../../../../../../../redux/slices/totalCount/totalCountSlice";
import { Link } from "react-router-dom";
import { formatWords2 } from "../../../../../../../utils/stringUtils";

const Submission = ({ data }) => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state?.totalCount);
  // Safe access to totalCount - it might be an object if API error occurred
  const totalCountRaw = value?.candidateSubmissions;
  const totalCount =
    typeof totalCountRaw === "number"
      ? totalCountRaw
      : totalCountRaw?.count || totalCountRaw?.data || 0;

  const { data: clientData, loading } = useSelector(
    (state) => state?.bdmJobs?.clientsubmissions,
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(
    25,
    (newPage, newLimit) => {},
  );

  // Clear data when candidate changes or component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearClientSubmissions());
    };
  }, [dispatch, data?.uiid]);

  useEffect(() => {
    // Clear previous data before fetching new
    dispatch(clearClientSubmissions());

    // ... rest of fetch logic is in other effect
  }, [dispatch, data?.uiid]);

  const columns = [
    {
      key: "id",
      label: "S No.",
    },
    {
      key: "code",
      label: "Job Code",
      render: (row) => (
        // <Link to={`/ats/jobs/job-details`} className="text-info">
        //   {row.code}
        // </Link>
        // <Link to={`/ats/jobs/job-details`} className="text-info" state={{ uiid: row.jobPostId }} onClick={() => {
        //     sessionStorage.setItem("selectedJobUiid", row.jobPostId);
        //     sessionStorage.setItem("prevJobsPage", window.location.pathname + window.location.search);
        // }}>
        //     {row?.code}
        // </Link>
        <Link
          to="/ats/jobs/job-details"
          className="text-info"
          state={{ uiid: row.jobPostId, applicantId: data?.uiid }}
          onClick={() => {
            sessionStorage.setItem("selectedJobUiid", row.jobPostId);
            sessionStorage.setItem("prevJobsPage", window.location.pathname + window.location.search);
          }}
        >
          {row.code}
        </Link>
        // <Link to={`/ats/jobs/job-details/${row.uiid}`} className="text-info">
        //   {row.code}
        // </Link>
      ),
    },
    { key: "jobTitle", label: "Job Title" },
    { key: "companyName", label: "Account Name" },
    {
      key: "submittedBy",
      label: "Submitted By",
    },
  ];

  // const mappedRowsJobDetails = mapTableRows(rowJobDetails, colJobDetails);

  const clientdata = clientData || [];

  const rows = clientdata.map((item, index) => {
    return {
      id: index + 1,
      uiid: item?.uiid,
      jobPostId: item?.jobPostId?.uiid || "",
      code: item?.jobPostId?.jobInfo?.jobCode || "",
      jobTitle: formatWords2(item?.jobPostId?.jobId?.title || ""),
      companyName: formatWords2(item?.jobPostId?.companyId?.name || "N/A"),
      submittedBy: formatWords2(
        (item?.addedBy?.firstName || "") +
          " " +
          (item?.addedBy?.lastName || ""),
      ),
    };
  });

  const mappedRows = mapTableRows(rows, columns);

  // const fetchAllJobs = () => {
  //     dispatch(
  //         totalCountStart({
  //             collection: "jobpostings",
  //             coll: "JobPosting",
  //             //tname: "allJobsPosts",
  //             app: "ats",
  //             // filters: { "statusHistory.status": { type: "EXCLUDE", value: 1 }, "notifyTo": { type: "NONE", value: user.data.uiid } },
  //         })
  //     );
  //     dispatch(
  //         fetchAllJobsStart({
  //             coll: "JobPosting",
  //             lim: limit,
  //             pg: page,
  //             // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
  //             //ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
  //             // ref: "Job Note Submission",
  //             // ref: "Job",
  //            // ref: "Job Submission",
  //             // fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 }, "notifyTo": { type: "NONE", value: user.data.uiid } },
  //             // extret: "uiid firstName",
  //             //incl: ["", "uiid statusHistory.status"],
  //             sort: { addedOn: -1 },
  //         })
  //     );
  // }
  // const bdmJobs = useSelector((state) => state.bdmJobs);
  // console.log("bdmJobs slice:", bdmJobs);

  const fetchAllJobs = () => {
    dispatch(
      fetchClientSubmissionsStart({
        coll: "Submission",
        lim: limit,
        pg: page,
        useAggregate: false,
        fil: {
          candidateId: {
            type: "NONE",
            value: data?.uiid,
          },
        },
        sort: { addedOn: -1 },
        ref: "JobPosting Candidate AddedBy",
        incl: [
          "uiid jobInfo jobTitle companyId jobId",
          "uiid firstName",
          "uiid firstName lastName",
        ], // Select fields for populated refs: Job, Candidate, AddedBy
        ret: "uiid jobPostId candidateId companyId addedBy addedOn", // Select fields for main doc
      }),
    );
  };

  useEffect(() => {
    if (loading || !data?.uiid) return; // Don't fetch if already loading or no candidateId

    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "candidateSubmissions",
        app: "ats",
        filters: {
          candidateId: { type: "NONE", value: data?.uiid },
        },
        useAggregate: false,
      }),
    );
    fetchAllJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.uiid, dispatch, limit, page]);

  return (
    <>
      <TableAdv
        tableId={"applicants_allapplicants_submission"}
        columns={columns}
        rows={mappedRows}
        limit={limit}
        page={page}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        totalCount={totalCount}
        serverPagination
        toolbarRight={{
          fullScreen:true
        }}
      />
    </>
  );
};

export default Submission;
